import { render, staticRenderFns } from "./FiltersTable.vue?vue&type=template&id=3b5c8a4f&scoped=true&"
import script from "./FiltersTable.vue?vue&type=script&lang=ts&"
export * from "./FiltersTable.vue?vue&type=script&lang=ts&"
import style0 from "./FiltersTable.vue?vue&type=style&index=0&id=3b5c8a4f&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5c8a4f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCardText,VCardTitle,VIcon,VSpacer})
